module.exports = __webpack_public_path__ + "static/media/saturday-in-german.ec626040.png";